<div class="p-6 space-y-4">
  <h1 class="text-2xl font-semibold">Easy Store Front</h1>
</div>

<router-outlet></router-outlet>